import React from 'react';

// phone
import PhoneInput from '../components/phone.component';

// hook forms
import { useForm } from 'react-hook-form';

const PeopleEventPage = () => {
  const { register, handleSubmit, setValue, errors } = useForm();

  const onSubmit = (data) => {
    console.log('data', data);

    try {
    } catch (error) {
      console.log('error', error);
    }
  };

  const cancel = () => {
    setValue('fullName', '');
    document.getElementById('phone').value = '';
    setValue('fullName', '');
    setValue('email', '');
    setValue('address', '');
  };
  return (
    <div className='container'>
      <div className='row d-flex justify-content-center'>
        <div className='col col-md-6'>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div class='form-group'>
              <label for='exampleInputEmail1'>
                <strong>Nombre Completo</strong>
              </label>
              <input
                type='fullName'
                class='form-control'
                id='fullName'
                name='fullName'
                aria-describedby='fullName'
                placeholder='Nombre completo'
                ref={register({ required: true })}
              />
              {errors.fullName && (
                <small
                  name='errorFullName'
                  id='errorFullName'
                  class='form-text text-danger'
                >
                  El Nombre es un campo requerido
                </small>
              )}
            </div>
            <div class='form-group'>
              <label for='phone'>
                <strong>Teléfono</strong>
              </label>
              <PhoneInput
                className='form-control'
                name='phone'
                id='phone'
                placeholder='Teléfono'
              />
              <small
                name='errorFullName'
                id='errorFullName'
                class='form-text text-muted'
              >
                Use el formato +54 9999 9999 999
              </small>
            </div>
            <div class='form-group'>
              <label for='exampleInputPassword1'>
                <strong>Correo electrónico</strong>
              </label>
              <input
                type='text'
                class='form-control'
                id='email'
                name='email'
                placeholder='Correo electrónico'
                ref={register}
              />
            </div>
            <div class='form-group'>
              <label for='exampleInputPassword1'>
                <strong>Dirección</strong>
              </label>
              <input
                type='text'
                class='form-control'
                id='address'
                name='address'
                placeholder='Dirección'
                ref={register({ required: true })}
              />
            </div>
            {errors.fullName && (
              <small
                name='errorFullName'
                id='errorFullName'
                class='form-text text-danger'
              >
                La dirección es un campo requerido
              </small>
            )}
            <div className='mt-3'>
              <button type='submit' class='btn btn-primary'>
                Guardar
              </button>
              <button
                type='button'
                onClick={cancel}
                class='ml-3 btn btn-secondary'
              >
                Cancelar
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default PeopleEventPage;
